'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var CircularProgress = require('@material-ui/core/CircularProgress');
var styles = require('@material-ui/core/styles');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var CircularProgress__default = /*#__PURE__*/_interopDefaultLegacy(CircularProgress);

var _excluded = ["className", "size"];
function CircleLoader(props) {
  var theme = styles.useTheme();

  var {
    className,
    size = 40
  } = props,
      restProps = _rollupPluginBabelHelpers.objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: className,
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: size,
      height: size
    }
  }, /*#__PURE__*/React__default['default'].createElement(CircularProgress__default['default'], _rollupPluginBabelHelpers['extends']({
    sx: {
      color: theme.palette.grey[theme.palette.mode === 'light' ? 300 : 700]
    },
    variant: "determinate",
    size: size,
    thickness: 4
  }, restProps, {
    value: 100
  })), /*#__PURE__*/React__default['default'].createElement(CircularProgress__default['default'], _rollupPluginBabelHelpers['extends']({
    sx: {
      color: theme.palette.primary.main,
      animationDuration: '1200ms',
      position: 'absolute',
      left: 0,
      '& .MuiCircularProgress-circle': {
        strokeLinecap: 'round'
      }
    },
    variant: "indeterminate",
    disableShrink: true,
    size: size,
    thickness: 4
  }, restProps)));
}
CircleLoader.propTypes = {
  className: index.string,
  size: index.number
};

exports.CircleLoader = CircleLoader;
exports.default = CircleLoader;
